module.exports = __webpack_public_path__ + "static/media/SV1_05_Tilt_1000.26b6ba95.jpg";